<div class="marketing-page">
  <div class="topline">
    <div>
      <h2>Marketing Campaigns</h2>
      <div class="subtitle">Campaign setup, audience groups, and delivery history.</div>
    </div>
  </div>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="marketing-tabs">
    @for (tab of tabs; track tab) {
      <a
        mat-tab-link
        (click)="gotoTab(tab)"
        [active]="tab.link == activeTab.link"
        >
        {{tab.title}}
      </a>
    }
  </nav>

  <mat-tab-nav-panel #tabPanel>
    @if (activeTab.id === 'list') {
      <app-marketing-campaigns-list></app-marketing-campaigns-list>
    }
    @if (activeTab.id === 'sequences') {
      <app-marketing-campaigns-sequences></app-marketing-campaigns-sequences>
    }
    @if (activeTab.id === 'groups') {
      <app-marketing-campaigns-groups></app-marketing-campaigns-groups>
    }
    @if (activeTab.id === 'history') {
      <app-marketing-campaigns-history></app-marketing-campaigns-history>
    }
  </mat-tab-nav-panel>
</div>
